import React from "react";
import { Card, Form, Input, Button, Typography } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import AuthLayout from "../../layouts/auth/AuthLayout";

const { Title, Text } = Typography;

const EnterMobile = () => {
  const onFinish = (values) => {
    console.log("Mobile:", values);
  };

  return (
    <AuthLayout title="Welcome Back 👋">

      <Card
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 14,
          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        }}
      >
        <Title level={3} style={{ textAlign: "center", marginBottom: 10 }}>
          Reset Password
        </Title>

        <Text
          style={{
            display: "block",
            textAlign: "center",
            marginBottom: 20,
            color: "#666",
          }}
        >
          Enter your mobile number to receive OTP
        </Text>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Mobile Number"
            name="mobile"
            rules={[
              { required: true, message: "Please enter mobile number" },
            ]}
          >
            <Input
              prefix={<MobileOutlined />}
              placeholder="Enter mobile number"
              size="large"
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" block size="large">
            Send OTP
          </Button>
        </Form>
      </Card>

    </AuthLayout>
  );
};

export default EnterMobile;
